import React, { useState, useRef, useEffect } from "react";
import { MessageCircle, X, Send, Loader2, Bot } from "lucide-react";
import { api } from "../lib/api";
import { Button } from "./ui/button";
import { Textarea } from "./ui/textarea";

export default function SupportBot() {
  const [open, setOpen] = useState(false);
  const [msgs, setMsgs] = useState([{ role: "assistant", content: "مرحبًا بك في AQL4! أنا مساعدك الرقمي. كيف أخدمك اليوم؟" }]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const sid = useRef("g-" + Math.random().toString(36).slice(2, 8));
  const scroller = useRef(null);
  useEffect(() => { scroller.current?.scrollTo({ top: 9e9, behavior: "smooth" }); }, [msgs, loading, open]);

  const send = async () => {
    if (!input.trim() || loading) return;
    const t = input.trim(); setInput(""); setMsgs((m) => [...m, { role: "user", content: t }]); setLoading(true);
    try { const r = await api.supportChat({ message: t, session_id: sid.current }); setMsgs((m) => [...m, { role: "assistant", content: r.content }]); }
    catch (e) { setMsgs((m) => [...m, { role: "assistant", content: "عذرًا، تعذّر الرد الآن. حاول لاحقًا." }]); }
    setLoading(false);
  };

  return (
    <>
      <button onClick={() => setOpen((o) => !o)}
        className="fixed bottom-5 left-5 z-[60] flex h-14 w-14 items-center justify-center rounded-2xl brand-gradient text-[#052027] shadow-2xl transition-transform hover:scale-105"
        aria-label="بوت الدعم">
        {open ? <X className="h-6 w-6" /> : <MessageCircle className="h-6 w-6" />}
      </button>

      {open && (
        <div className="fixed bottom-24 left-5 z-[60] flex h-[70vh] max-h-[560px] w-[92vw] max-w-sm flex-col overflow-hidden rounded-3xl border border-white/10 bg-[#0b1116] shadow-2xl" dir="rtl">
          <div className="flex items-center gap-2 border-b border-white/5 bg-white/[0.03] px-4 py-3">
            <span className="flex h-9 w-9 items-center justify-center rounded-xl brand-gradient text-[#052027]"><Bot className="h-5 w-5" /></span>
            <div><p className="text-sm font-bold text-white">مساعد AQL4</p><p className="text-[11px] text-cyan">متصل الآن · يعمل بالذكاء</p></div>
          </div>
          <div ref={scroller} className="flex-1 space-y-3 overflow-y-auto p-4">
            {msgs.map((m, i) => (
              <div key={i} className={`flex ${m.role === "user" ? "justify-start" : "justify-end"}`}>
                <div className={`max-w-[85%] whitespace-pre-wrap rounded-2xl px-3.5 py-2 text-sm leading-relaxed ${m.role === "user" ? "bg-white/5 text-white" : "border border-cyan/20 bg-cyan/5 text-cyan-50"}`}>{m.content}</div>
              </div>
            ))}
            {loading && <div className="flex justify-end"><div className="rounded-2xl border border-cyan/20 bg-cyan/5 px-3.5 py-2"><Loader2 className="h-4 w-4 animate-spin text-cyan" /></div></div>}
          </div>
          <div className="flex gap-2 border-t border-white/5 p-3">
            <Textarea value={input} onChange={(e) => setInput(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); send(); } }} rows={1} placeholder="اكتب رسالتك…" className="max-h-24 resize-none border-white/10 bg-white/5 text-right text-white" />
            <Button onClick={send} disabled={loading} className="btn-cyan h-auto rounded-xl px-3.5 hover:bg-transparent">{loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />}</Button>
          </div>
        </div>
      )}
    </>
  );
}
